var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',{staticStyle:{"float":"right"},attrs:{"loading":_vm.syncing,"disabled":_vm.syncing},on:{"click":_vm.syncBuildingCustomerToAfas}},[_vm._v("Synchroniseer koper naar AFAS")])
}
var staticRenderFns = []

export { render, staticRenderFns }